export default __webpack_public_path__ + "static/media/Barlow-Black.5b6aa950.ttf";